export const ROUTES = {
  AUTH: {
    LOGIN: "login",
    FORGOT_PASSWORD: "forgot-password",
    RESET_PASSWORD: "reset-password",
    FORBIDDEN: "forbidden",
  },
  DASHBOARD: {
    PATH: "dashboard",
  },

  /**
   * INVENTORY
   */
  INVENTORY: {
    PATH: "inventory",

    // purchase orders
    PURCHASE_ORDERS: "purchase-orders",
    CREATE_PURCHASE_ORDER: `create-purchase-order`,
    PURCHASE_ORDER_DETAILS: `purchase-details/:id`,

    // inventory received
    INVENTORY_RECEIVED: "inventory-received",
    INVENTORY_RECEIVED_DETAILS: `inventory-received-details/:id`,
    EDIT_INVENTORY_RECEIVED: `edit-inventory-received`,

    // sales
    SALES: "sales",
    CREATE_SALE: `create-sale`,
    CHECKOUT_SALE: `checkout-sale`,
    SALE_SUCCESSFUL: `sale-successful`,
    SALE_DETAILS: `sale-details/:id`,

    // credit management
    CREDIT_MANAGEMENT: "credit-management",
    UNPAID_INVOICES: "unpaid-invoices",
    EXPENSES_MANAGEMENT: "expenses-management",
  },

  REPORTS: {
    PATH: "reports",
    CREDIT_MANAGEMENT: {
      PATH: "credit-management",
      UNPAID_INVOICES: "unpaid-invoices",
      CREDIT_ACTIVITY: "credit-activity",
      PAYMENT_TRENDS: "payment-trends",
      VISUALIZATION: "visualization",
    },
    EXPENSES: {
      PATH: "expenses",
      REGISTER: "expenses-register",
      CATEGORY_SUMMARY: "category-summary",
      CASH_ACCOUNT_SUMMARY: "account-summary",
      VISUALIZATION: "visualization",
    },
  },

  /**
   * CONFIGURATION
   */
  CONFIGURATION: {
    PATH: "configuration",
    ITEMS: "items",
    ITEM_DETAILS: "item-details/:id",
    SUPPLIERS: "suppliers",
    CUSTOMERS: "customers",
    CUSTOMER_DETAILS: `customer-details/:id`,
    ITEM_CATEGORIES: "item-categories",
    BRANCHES: "branches",
    STAFF: "staff",
    PAYMENT_ACCOUNTS: "payment-accounts",
    EXPENSES_CATEGORIES: "expenses-categories",
  },

  ADMIN: {
    PATH: "admin",
    DASHBOARD: "dashboard",
    BUSINESSES: `businesses`,
    BUSINESS_ADMINS: `business/admins`,
  },
};
